import React, { useEffect, useRef } from 'react';
import './FloatingDecorations.css';

// 16个学科元素的CDN地址
const SUBJECT_ELEMENTS = [
  // 数学
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/6fc32f44-c8d0-4ff3-ab40-f4861251f479/d7226b26-be7a-4a7b-8512-86ee7a8f93d9.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/2e8f42c5-90f3-467f-8a46-0fe978d549b6/93587c75-ecac-4c1c-a86f-39738ea4f3f0.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/aaba908e-d4f1-449e-a42f-a295afa98f98/f945ab57-4708-4090-9ea5-08dd6cf337eb.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/28eb3164-d1b0-433f-b440-bfe231404c83/a18f3091-6c00-486b-bcef-72cbeec83524.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/e829f9ca-5cb0-427c-be3f-c020795da6ad/dd285d0d-2dcf-4b6b-8d13-d75641d70d63.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/8c1f4ab1-bf8f-48d3-9683-d1862d6c49df/c3c066b2-1ce9-4900-9f47-d49cd3b74ccf.png',
  // 化学
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/b4c70f9e-d0b8-4cca-9581-ee55496cbf91/61f349f7-46a8-4f7d-bb0d-b467721874f7.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/e1b665c3-1374-4acd-a63b-c7df7fda956a/8806c218-dd61-4057-83c3-dd3a27590e53.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/5ad5aebf-d468-4625-8dc2-9e97fc31e313/10874167-98b3-46ee-a46d-aceab6efff58.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/9df6f7a6-f331-4067-90d2-eb78773d2b03/49edf7d8-ba15-456e-b3a9-f7a8149e0f8f.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/73883861-8900-4876-8b16-3ba6ca70261b/636a5a4a-81e2-4c4e-802b-1bd37c92d571.png',
  // 物理
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/6975f5a9-ed7b-4836-9021-6466b707d39d/2ea91c2a-7626-447d-ad5a-4a8502ea67ec.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/988db1dc-692a-4b98-8027-be9e6831068e/5174d012-7ad2-470d-81f8-b59d90f2a959.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/c633f515-a544-4af9-bc04-e323606578a9/505d7c55-b23a-4e88-ba27-cb935e370798.png',
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/c555dcf2-f8ce-42f2-981f-1ca519f233d0/1d5caaca-5dcb-4d9d-b220-ae87daac0fcb.png',
  // 生物
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/1b1d91e5-3efc-4551-a352-105a7e6fe0e4/4ad0a212-4841-40a3-a9b7-a6c86e674258.png',
];

// 需要保持100%透明度的化学元素URL（Ca、K+、Fe）
const FULL_OPACITY_URLS = [
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/b4c70f9e-d0b8-4cca-9581-ee55496cbf91/61f349f7-46a8-4f7d-bb0d-b467721874f7.png', // Ca
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/e1b665c3-1374-4acd-a63b-c7df7fda956a/8806c218-dd61-4057-83c3-dd3a27590e53.png', // K+
  'https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-12-02/5ad5aebf-d468-4625-8dc2-9e97fc31e313/10874167-98b3-46ee-a46d-aceab6efff58.png', // Fe
];

interface FloatingElement {
  id: number;
  x: number;
  y: number;
  vx: number;
  vy: number;
  image: HTMLImageElement;
  alpha: number;
  maxAlpha: number; // 最大透明度（Ca/K+/Fe 为 1.0，其他为 0.5）
  life: number;
  maxLife: number;
  fadeInDuration: number;
  fadeOutDuration: number;
  width: number;
  height: number;
  rotation: number;
}

export function FloatingDecorations() {
  const containerRef = useRef<HTMLDivElement>(null);
  const elementsRef = useRef<FloatingElement[]>([]);
  const domRefs = useRef<(HTMLImageElement | null)[]>([]);

  useEffect(() => {
    let width = window.innerWidth;
    let height = 550; // 固定高度为 550px
    let loadedImages: HTMLImageElement[] = [];
    let availableIndices: number[] = [];
    let animationId: number;

    // 预加载所有图片
    const loadImages = async () => {
      const promises = SUBJECT_ELEMENTS.map((url) => {
        return new Promise<HTMLImageElement | null>((resolve) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = () => {
            console.error(`Failed to load image: ${url}`);
            resolve(null);
          };
          img.src = url;
        });
      });

      try {
        const results = await Promise.all(promises);
        loadedImages = results.filter((img): img is HTMLImageElement => img !== null);
        
        if (loadedImages.length === 0) {
          console.error('No images loaded successfully');
          return;
        }

        console.log(`Successfully loaded ${loadedImages.length} images`);
        availableIndices = Array.from({ length: loadedImages.length }, (_, i) => i);
        
        resize();
        initElements();
        if (!animationId) {
          animate();
        }
      } catch (error) {
        console.error('Error in image loading process:', error);
      }
    };

    const getRandomImageIndex = (): number => {
      if (availableIndices.length === 0) {
        availableIndices = Array.from({ length: SUBJECT_ELEMENTS.length }, (_, i) => i);
      }
      const randomIndex = Math.floor(Math.random() * availableIndices.length);
      const imageIndex = availableIndices[randomIndex];
      availableIndices.splice(randomIndex, 1);
      return imageIndex;
    };

    const createFloatingElement = (isInitial = false, id: number): FloatingElement => {
      const imageIndex = getRandomImageIndex();
      const img = loadedImages[imageIndex];
      const angle = Math.random() * Math.PI * 2;
      const speed = 0.1 + Math.random() * 0.15;
      
      const w = img.width / 3;
      const h = img.height / 3;

      const maxLife = 600 + Math.random() * 200;
      const life = isInitial ? Math.floor(Math.random() * (maxLife - 100)) : 0;

      const topPadding = 80;
      const sidePadding = 112;
      const minDistance = 150; // 元素之间的最小距离
      
      let x, y;
      const centerX = width / 2;
      const exclusionWidth = 700;
      const exclusionTop = 300;
      
      let safe = false;
      let attempts = 0;
      
      while (!safe && attempts < 100) {
        x = sidePadding + Math.random() * (width - sidePadding * 2);
        y = topPadding + Math.random() * (height - topPadding);
        
        const inExclusionZone = y > exclusionTop && Math.abs(x - centerX) < exclusionWidth / 2;
        
        // 检查与现有元素的距离
        let tooClose = false;
        for (const existingEl of elementsRef.current) {
          if (existingEl.id === id) continue; // 跳过自己（复用时）
          const dx = x - existingEl.x;
          const dy = y - existingEl.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < minDistance) {
            tooClose = true;
            break;
          }
        }
        
        if (!inExclusionZone && !tooClose) {
          safe = true;
        }
        attempts++;
      }
      
      // 如果尝试多次仍失败，放宽距离限制
      if (!safe) {
        x = sidePadding + Math.random() * (width - sidePadding * 2);
        y = topPadding + Math.random() * (exclusionTop - topPadding);
      }

      // 判断是否为需要100%透明度的化学元素（Ca、K+、Fe）
      const isFullOpacity = FULL_OPACITY_URLS.includes(img.src);
      const maxAlpha = isFullOpacity ? 1.0 : 0.5;

      return {
        id,
        x: x!,
        y: y!,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        image: img,
        alpha: isInitial ? maxAlpha : 0,
        maxAlpha: maxAlpha,
        life: life,
        maxLife: maxLife,
        fadeInDuration: 60,
        fadeOutDuration: 60,
        width: w,
        height: h,
        rotation: (Math.random() - 0.5) * (Math.PI / 3),
      };
    };

    const initElements = () => {
      elementsRef.current = [];
      for (let i = 0; i < 5; i++) {
        elementsRef.current.push(createFloatingElement(true, i));
      }
    };

    const updateElement = (element: FloatingElement) => {
      const centerX = width / 2;
      const exclusionWidth = 700;
      const exclusionTop = 300;
      
      if (element.y > exclusionTop) {
        if (Math.abs(element.x - centerX) < exclusionWidth / 2) {
          if (element.x < centerX) {
            element.vx = -Math.abs(element.vx || 0.1);
          } else {
            element.vx = Math.abs(element.vx || 0.1);
          }
        }
      }

      element.x += element.vx;
      element.y += element.vy;

      const topPadding = 80;
      const sidePadding = 112;
      const edgeFadeDistance = 80; // 边缘淡出开始的距离
      
      if (element.x < sidePadding || element.x > width - sidePadding) {
        element.vx *= -1;
        element.x = Math.max(sidePadding, Math.min(width - sidePadding, element.x));
      }
      if (element.y < topPadding || element.y > height) {
        element.vy *= -1;
        element.y = Math.max(topPadding, Math.min(height, element.y));
      }

      element.life++;

      // 计算基础透明度（基于生命周期的淡入淡出）
      let baseAlpha: number;
      if (element.life < element.fadeInDuration) {
        baseAlpha = (element.life / element.fadeInDuration) * element.maxAlpha;
      } else if (element.life > element.maxLife - element.fadeOutDuration) {
        const fadeOutProgress = (element.maxLife - element.life) / element.fadeOutDuration;
        baseAlpha = Math.max(0, fadeOutProgress * element.maxAlpha);
      } else {
        baseAlpha = element.maxAlpha;
      }

      // 计算边缘淡出系数
      let edgeFade = 1.0;
      
      // 左边缘淡出
      const distFromLeft = element.x - sidePadding;
      if (distFromLeft < edgeFadeDistance) {
        edgeFade = Math.min(edgeFade, distFromLeft / edgeFadeDistance);
      }
      
      // 右边缘淡出
      const distFromRight = (width - sidePadding) - element.x;
      if (distFromRight < edgeFadeDistance) {
        edgeFade = Math.min(edgeFade, distFromRight / edgeFadeDistance);
      }
      
      // 上边缘淡出
      const distFromTop = element.y - topPadding;
      if (distFromTop < edgeFadeDistance) {
        edgeFade = Math.min(edgeFade, distFromTop / edgeFadeDistance);
      }
      
      // 下边缘淡出
      const distFromBottom = height - element.y;
      if (distFromBottom < edgeFadeDistance) {
        edgeFade = Math.min(edgeFade, distFromBottom / edgeFadeDistance);
      }

      // 应用边缘淡出
      element.alpha = baseAlpha * Math.max(0, edgeFade);
    };

    const animate = () => {
      const elements = elementsRef.current;
      
      for (let i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        updateElement(element);

        if (element.life >= element.maxLife) {
          elements[i] = createFloatingElement(false, element.id);
        }
      }

      elements.forEach((el, index) => {
        const dom = domRefs.current[index];
        if (dom && el.image) {
          if (dom.src !== el.image.src) {
            dom.src = el.image.src;
          }
          dom.style.transform = `translate3d(${el.x - el.width/2}px, ${el.y - el.height/2}px, 0) rotate(${el.rotation}rad)`;
          dom.style.opacity = el.alpha.toString();
          dom.style.width = `${el.width}px`;
          dom.style.height = `${el.height}px`;
        }
      });

      animationId = requestAnimationFrame(animate);
    };

    const resize = () => {
      width = window.innerWidth;
      height = 550;
    };

    resize();
    loadImages();

    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <div className="floating-container" ref={containerRef}>
      <div className="floating-background" />
      {[0, 1, 2, 3, 4].map((i) => (
        <img 
          key={i}
          ref={(el) => { domRefs.current[i] = el; }}
          className="floating-element"
          alt=""
        />
      ))}
    </div>
  );
}
